<template>
  <!-- App.vue -->
  <v-app v-if="isAdmin">
    <AdminHeader v-if="!preLogin"></AdminHeader>
    <v-navigation-drawer app v-if="!preLogin" class="sidebar-app">
      <AdminSideBar />
    </v-navigation-drawer>
    <router-view></router-view>
    <v-footer app v-if="!preLogin">
    </v-footer>
  </v-app>
  <v-app v-else>
    <Header v-if="!isPublic"></Header>
    <Header v-if="isHeader&&isAuthenticated"></Header>
    <!-- Sizes your content based upon application components -->
    <v-navigation-drawer app v-if="!isPublic" class="sidebar-app">
      <SideBar />
    </v-navigation-drawer>
    
    <v-main v-bind:class="{'main-box': !isPublic}">
      <!-- {{'Hello' + isPublic}} -->
      <!-- Provides the application the proper gutter -->
      <v-container fluid v-if="isPublic">

        <!-- If using vue-router -->
        <router-view></router-view>
      </v-container>
      <v-container fluid v-if="(isAuthenticated)&&(!isPublic)" class="dashboard-conatainer" fill-height>
        <!-- <v-container fill-height > -->
            <!-- If using vue-router -->
          <router-view></router-view>
        <!-- </v-container> -->
      </v-container>
    </v-main>

    <v-footer app v-if="!isPublic">
      <!-- -->
    </v-footer>
  </v-app>
</template>

<style>
  @import './assets/styles/index.css';
</style>

<script>
import Header from './components/common/Header.vue';
import AdminHeader from './components/common/AdminHeader.vue';
import SideBar from './components/common/SideBar.vue';
import AdminSideBar from './components/common/AdminSideBar.vue';

import { Auth } from 'aws-amplify';
// import { GET_PROFILE_DETAIL, GET_REFERRAL_DETAIL } from "./store/actions.type";
import axios from "axios";
export default {
  name: 'App',
  components: {
    Header,
    AdminHeader,
    SideBar,
    AdminSideBar,
  },
  data: () => ({
  }),
  computed: {
    isAuthenticated(){
      return this.$store.getters.getProfileDetail ? true : false;
    },
    isPublic() {
      return this.$route.meta.isPublic ? true : false;
    },
    
    isHeader() {
      return this.$route.meta.isHeader == true;
    },
    isAdmin() {
      return this.$route.meta.isAdmin == true;
    },
    preLogin() {
      return this.$route.meta.preLogin == true;
    }
  },
  methods: {
   
  },
  mounted (){
    
  }
};
</script>
<style type="text/css">
  .sidebar-app{
    top:170px !important;
    padding-left:70px !important;
  }
  .main-conatiner-dashboard{
    padding:0px 0px 0px 0px !important;
  }
  .dashboard-conatainer{
    padding:50px 50px 50px 50px !important;
  }
</style>
